import { useState, useEffect } from "react";
import { isDarkMode } from "../../utils/constants";
import { Box } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import SideArrow from "../../../javascript/images/SideArrow.png";
import SideArrowBlack from "../../../javascript/images/SideArrowBlack.png";
import { handleSharing } from "../../utils/share";
import { userShareExperienceButton } from "../../../javascript/api/user";

const ChatButton = (props) => {
  const {
    questionNumber,
    q,
    action,
    onRecommendedAction,
    onQuestionSubmit,
    transitionFlowButtonsAmount,
    preventQuestionInput,
    setPreventQuestionInput,
    isSecondaryExperience,
    secondaryExperienceType,
    userData,
    setUserData,
    setModalVisible,
    setShowChatShare,
    compactSuggestedAction = false,
  } = props;

  const [pulsateButton, setPulsateButton] = useState(false);

  let buttonChatClass = isDarkMode
    ? "button-chat-box dark chat-message button"
    : "button-chat-box chat-message button";

  const regularButtonStyle = isDarkMode
    ? {
        background:
          "linear-gradient(135deg, rgba(39, 46, 61, 0.96), rgba(27, 31, 40, 0.96))",
        color: "#f8fafc",
        border: "1px solid rgba(148, 163, 184, 0.24)",
        boxShadow:
          "0 18px 42px rgba(0, 0, 0, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.08)",
      }
    : {
        background:
          "linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(239, 244, 251, 0.98))",
        color: "#111827",
        border: "1px solid rgba(100, 116, 139, 0.2)",
        boxShadow:
          "0 16px 36px rgba(15, 23, 42, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.9)",
      };
  let buttonColor = isDarkMode ? "#252525" : "#ECEEF3";
  let topMargin = "2px";
  let showTrailingArrow = true;
  if (isSecondaryExperience && secondaryExperienceType === "ask-share") {
    showTrailingArrow = false;
    if (questionNumber === 1) {
      topMargin = "50px";
      buttonChatClass = isDarkMode
        ? "button-chat-box-ask-share-1 dark chat-message button"
        : "button-chat-box-ask-share-1 chat-message button";
    } else {
      topMargin = "30px";
      buttonChatClass = isDarkMode
        ? "button-chat-box-ask-share-2 dark chat-message button"
        : "button-chat-box-ask-share-2 chat-message button";
      buttonColor = isDarkMode ? "#252525" : "#F0F5FF";
    }
  }

  useEffect(() => {
    // if (secondaryExperienceType == "new-user") {
    setTimeout(() => {
      setPulsateButton(true);
    }, 3800);
    // }
  }, []);

  return (
    <Box
      sx={{
        opacity: transitionFlowButtonsAmount,
        transition: "opacity .7s",
        marginTop: topMargin,
        zIndex: 1,
        maxWidth: "100%",
        ...(compactSuggestedAction
          ? {
              marginTop: 0,
              flex: "0 1 auto",
            }
          : {}),
      }}
      className="outgoing_container"
    >
      <Box
        sx={{
          padding: compactSuggestedAction ? 0 : "2px 0px 10px 0px",
          maxWidth: "100%",
        }}
      >
        <Box
          sx={{
            margin: "auto",
            color: isDarkMode
              ? "#f5f5f5"
              : secondaryExperienceType
              ? "#121212"
              : "#121212",
          }}
        >
          <Box className="bubble_container">
            <Box sx={{ position: "relative" }}>
              <Box
                component="button"
                type="button"
                disabled={preventQuestionInput}
                aria-label={typeof q === "string" ? q : "Suggested follow-up"}
                onClick={() => {
                  if (!preventQuestionInput) {
                    setTimeout(() => {
                      if (
                        !secondaryExperienceType ||
                        secondaryExperienceType == "new-user"
                      ) {
                        if (action && onRecommendedAction?.(action)) {
                          return;
                        }
                        const submitted = onQuestionSubmit(q);
                        if (submitted === false) {
                          setPreventQuestionInput(false);
                        }
                        setUserData({
                          ...userData,
                          showAskShareMessage: false,
                        });
                      } else if (secondaryExperienceType == "ask-share") {
                        if (questionNumber == 1) {
                          handleSharing(
                            setModalVisible,
                            setShowChatShare,
                            false
                          );
                          setTimeout(() => {
                            setUserData({
                              ...userData,
                              showAskShareMessage: false,
                            });
                          }, 1500);
                          setPreventQuestionInput(false);
                          userShareExperienceButton("share");
                        } else {
                          setUserData({
                            ...userData,
                            showAskShareMessage: false,
                          });
                          setPreventQuestionInput(false);
                          userShareExperienceButton("continue");
                        }
                      }
                    }, 50);
                  }
                }}
                className={buttonChatClass}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  background: buttonColor,
                  appearance: "none",
                  border: "none",
                  fontFamily:
                    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  fontSize: isSecondaryExperience ? undefined : "15px",
                  fontWeight: 650,
                  lineHeight: 1.25,
                  letterSpacing: 0,
                  whiteSpace: "normal",
                  textAlign: "left",
                  overflowWrap: "anywhere",
            
                  animation:
                    questionNumber == 1 &&
                    isSecondaryExperience &&
                    pulsateButton
                      ? isDarkMode
                        ? "pulsate-dark 1.5s 9"
                        : "pulsate 1.5s 9"
                      : "",
                  minWidth: isSecondaryExperience
                    ? "160px"
                    : "min(220px, calc(100vw - 48px))",
                  maxWidth: isSecondaryExperience
                    ? "440px"
                    : "min(680px, calc(100vw - 48px))",
                  minHeight: !isSecondaryExperience ? "44px" : undefined,
                  justifyContent: showTrailingArrow ? "space-between" : "center",
                  transition:
                    "transform 0.18s ease, opacity 0.2s ease-in-out, border-color 0.18s ease, box-shadow 0.18s ease",
                  ...(!isSecondaryExperience ? regularButtonStyle : {}),
                  "&:hover": {
                    opacity: preventQuestionInput ? 0.72 : 1,
                    transform: preventQuestionInput ? "none" : "translateY(-1px)",
                    cursor: preventQuestionInput ? "not-allowed" : "pointer",
                  },
                  "&:active": {
                    transform: "translateY(0)",
                  },
                }}
              >
                <Box component="span" sx={{ minWidth: 0 }}>
                  {q}
                </Box>
                {showTrailingArrow && (
                  <Box
                    component="span"
                    aria-hidden="true"
                    sx={{
                      width: 22,
                      height: 22,
                      flex: "0 0 auto",
                      borderRadius: "50%",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: isDarkMode
                        ? "rgba(147, 197, 253, 0.16)"
                        : "rgba(37, 99, 235, 0.1)",
                      color: isDarkMode ? "#bfdbfe" : "#1d4ed8",
                    }}
                  >
                    <ArrowForwardRoundedIcon sx={{ fontSize: 16 }} />
                  </Box>
                )}

                {questionNumber == 2 &&
                  secondaryExperienceType == "ask-share" && (
                    <Box
                      sx={{
                        height: "100%",
                        marginLeft: "10px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={isDarkMode ? SideArrow : SideArrowBlack}
                        style={{
                          height: "18px",
                          maxWidth: "100%",
                          maxHeight: "100%",
                        }}
                      />
                    </Box>
                  )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatButton;
